import {Injectable} from '@angular/core';
import {ScanditProvider} from "../../../providers/scandit/scandit.provider";
import {SettingsService} from "../../storage/settings/settings.service";
import {ScanditModel} from "../../../models/scandit/Scandit";
import {Events} from "@ionic/angular";
import {CarriersService} from "../../endpoint/carriers/carriers.service";
import {environment as al_environment} from "../../../../../../apps/al/src/environments/environment";
import {ItemReferencesProvider} from "../../../providers/item-references/item-references.provider";
import {environment} from "@suite/services";

declare let ScanditMatrixSimple;

@Injectable({
  providedIn: 'root'
})
export class TransferPackingScanditService {

  private EXIT_FROM_SCANDIT: string = 'exit_from_scandit';
  private timeoutHideText;

  private isProcessStarted: boolean = false;
  private packingReferenceOrigin: string = null;
  private lastCodeScanned: string = 'start';

  private disableTransferProductByProduct: boolean = true;

  private readonly timeMillisToResetScannedCode: number = 1000;

  constructor(
    private events: Events,
    private settingsService: SettingsService,
    private carriersService: CarriersService,
    private scanditProvider: ScanditProvider,
    private itemReferencesProvider: ItemReferencesProvider
  ) {
    this.timeMillisToResetScannedCode = al_environment.time_millis_reset_scanned_code;
  }

  async transfer() {
    let timeoutStarted = null;

    ScanditMatrixSimple.initSwitchToIonic((res: ScanditModel.ResponseSwitchToIonic) => {
      if (res && res.result && res.actionIonic) {
        this.executeAction(res.actionIonic, res.params);
      }
      if (res) {
        if (res.barcode) {
          this.settingsService.saveDeviceSettings({ transferPackingLastMethod: 'scandit' });

          let codeScanned = res.barcode.data;

          if (codeScanned != this.lastCodeScanned) {
            this.lastCodeScanned = codeScanned;

            if (timeoutStarted) {
              clearTimeout(timeoutStarted);
            }
            timeoutStarted = setTimeout(() => this.lastCodeScanned = 'start', this.timeMillisToResetScannedCode);

            if (this.itemReferencesProvider.checkCodeValue(codeScanned) == this.itemReferencesProvider.codeValue.PACKING) {
              if (this.isProcessStarted) {
                this.transferAmongPackings(codeScanned);
              } else {
                ScanditMatrixSimple.showLoadingDialog('Iniciando proceso...');
                ScanditMatrixSimple.setTimeout("setPackingReference", 1 * 1000, JSON.stringify([codeScanned]));
              }
            } else if (this.itemReferencesProvider.checkCodeValue(codeScanned) == this.itemReferencesProvider.codeValue.PRODUCT
              || this.itemReferencesProvider.checkCodeValue(codeScanned) == this.itemReferencesProvider.codeValue.PRODUCT_MODEL) {
              if (this.isProcessStarted) {
                if (this.disableTransferProductByProduct) {
                  ScanditMatrixSimple.setText(
                    'Funcionalidad de traspaso de producto por producto no disponible actualmente.',
                    this.scanditProvider.colorsMessage.error.color,
                    this.scanditProvider.colorText.color,
                    16);
                  this.hideTextMessage(1500);
                }
              } else {
                ScanditMatrixSimple.setText(
                  'El código escaneado no es válido para la operación que se espera realizar.',
                  this.scanditProvider.colorsMessage.error.color,
                  this.scanditProvider.colorText.color,
                  16);
                this.hideTextMessage(1500);
              }
            } else {
              ScanditMatrixSimple.setText(
                'El código escaneado no es válido para la operación que se espera realizar.',
                this.scanditProvider.colorsMessage.error.color,
                this.scanditProvider.colorText.color,
                16);
              this.hideTextMessage(1500);
            }
          }
        } else if (res.action) {
          if (res.action == 'matrix_simple') {
            // Scandit started
            ScanditMatrixSimple.setMainTextSwitchToIonic(true, 'Escanea el embalaje de origen');
          } else if (res.action == 'exit') {
            this.events.publish(this.EXIT_FROM_SCANDIT);
          } else if (res.action == 'request') {
            let responseData = null;

            if (res.data) {
              responseData = JSON.parse(res.data);
            }

            switch (res.requestType) {
              case "postTransferAmongPackings":
                ScanditMatrixSimple.hideLoadingDialog();
                ScanditMatrixSimple.setText(
                  'Traspaso de productos entre embalajes realizado.',
                  this.scanditProvider.colorsMessage.success.color,
                  this.scanditProvider.colorText.color,
                  16);
                this.hideTextMessage(1500);
                this.packingReferenceOrigin = null;
                this.isProcessStarted = false;
                this.lastCodeScanned = 'start';
                ScanditMatrixSimple.setMainTextSwitchToIonic(true, 'Escanea el embalaje de origen');
                ScanditMatrixSimple.setOriginTextSwitchToIonic(false, null);
                break;
            }
          }
        }
      }
    }, 'Traspaso', this.scanditProvider.colorsHeader.background.color, this.scanditProvider.colorsHeader.color.color);
  }

  private transferAmongPackings(destinyPacking) {
    ScanditMatrixSimple.showLoadingDialog('Traspasando productos...');
    ScanditMatrixSimple.request("POST", environment.apiBase + "/packing/transfer", { origin: this.packingReferenceOrigin, destiny: destinyPacking }, localStorage.getItem("access_token"), "postTransferAmongPackings");
  }

  private hideTextMessage(delay: number) {
    if (this.timeoutHideText) {
      clearTimeout(this.timeoutHideText);
    }
    this.timeoutHideText = setTimeout(() => {
      ScanditMatrixSimple.showText(false);
    }, delay);
  }

  private executeAction(action: string, paramsString: string){
    let params = [];
    try{
      params = JSON.parse(paramsString);
    } catch (e) {

    }
    switch (action){
      case 'setPackingReference':
        let codeScanned = params[0];
        ScanditMatrixSimple.hideLoadingDialog();
        this.isProcessStarted = true;
        this.packingReferenceOrigin = codeScanned;
        let mainText = this.disableTransferProductByProduct ? 'Escanea el embalaje de destino' : 'Escanea los productos a traspasar';
        ScanditMatrixSimple.setMainTextSwitchToIonic(true, mainText);
        ScanditMatrixSimple.setOriginTextSwitchToIonic(true, codeScanned);
        break;
    }
  }

}


